import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useFetch(url, deps = [], enabled = true) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const refetch = useCallback(async () => {
    if (!enabled || !url) return;
    setLoading(true);
    try {
      const r = await api.get(url);
      setData(r.data);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, enabled, ...deps]);
  useEffect(() => { refetch(); }, [refetch]);
  return { data, loading, error, refetch, setData };
}
